export default "/_next/static/images/service-health-desktop-3x-7fd98f856334df3f383edc0773c61dff.jpg";